module.exports = __webpack_public_path__ + "img/1518495508.629f25c4.jpg";